<template>
  <div class="bottle-scan-code">
    <div class="bottle-scan-code-content">
      <div @click="selectCodeShow = true">{{car_number || '请扫码或输入车牌号'}}</div>
      <img src="@/assets/images/Scan code_icon_scan.png" alt="" @click="openScan">
    </div>
    <van-popup v-model="selectCodeShow" :style="{ width: '86%' }">
      <van-field v-model="car_number" center clearable placeholder="请选择或者输入车牌号码" >
        <template #button>
          <van-button size="small" type="primary" @click="selectCarCode(car_number)">确定</van-button>
        </template>
      </van-field>
      <div class="car-code-box">
        <div class="car-code-item" v-for="(it,i) in carCodeList" :key="i" @click="selectCarCode(it)">
          {{it}}<van-icon name="cross" @click.stop="spliceCarCode(it)" />
        </div>

      </div>
    </van-popup>
    <div class="mask" v-if="codeLoading">
      <div>
        <van-loading type="spinner" color="#1989fa" />
        <div class="text">图片识别中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import {carLicense} from "@/api/flowPath"
export default {
  props: {
    car_number: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      selectCodeShow: false,
      carCodeList: [],
      codeLoading: false,
    }
  },
  created(){
    this.carCodeList = this.mixGetCache("carCodeList", [])
    window.takePhotoResult = (result) => {
      this.getBase64Text("data:image/jpeg;base64," + result.data)
    }
  },
  methods: {
    openScan(){
      JS.takePhote()
      console.log("打开相机")
    },
    selectCarCode(number){
      if(number == "")return Toast("车牌不能为空")
      this.car_number = number
      this.$emit('setCarCode', number)
      this.setCarCodeCache(number)
      this.selectCodeShow = false
    },
    // 压缩图片 获取base64数据
    getBase64Text(url){
      let image = new Image();
      image.src = url
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = 400;
        canvas.height = (image.height * 400) / image.width;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, 400, (image.height * 400) / image.width);
        
        var quality = 0.8;
        //这里的dataurl就是base64类型
        var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
        // this.imgUrl = dataURL
        this.getCarCode(dataURL)
      }
    },
    getCarCode(pic){
      console.log("成功发起请求")
      this.codeLoading = true
      carLicense({pic}).then(res => {
        this.codeLoading = false
        console.log(res,"ress")
        // console.log(res.data,"ress")
        if(res.data && res.data.number){
          this.$emit('setCarCode', res.data.number)
          this.setCarCodeCache(res.data.number)
          return false
        }
        Toast({message: ret.msg || '扫码错误，请重试'})
        // console.log(res.data.data.number)
      }).catch(err => {
        console.log(err,"err")
        this.codeLoading = false
        Toast({message:"请尝试重新拍照或者手动输入"})
      })
    },
    // 把码添加进缓存
    async setCarCodeCache(number){
      console.log("开始执行了")
      let carCodeList = this.carCodeList
      const findIndex = carCodeList.findIndex(it => it == number)
      if(findIndex != -1){
        carCodeList.splice(findIndex, 1)
      }
      carCodeList.unshift(number)
      this.carCodeList = carCodeList
      this.mixSetCache("carCodeList", carCodeList)
    },
  }

}
</script>

<style lang="scss" scoped>
.bottle-scan-code{
  padding: 0 2.8vw;
  padding-top: 20px;
  background: white;
  padding-bottom: 5vw;
  .bottle-scan-code-content{
    background: #eeeeee;
    display: flex;
    align-items: center;
    line-height: 13vw;
    border-radius: 1vw;
    div{
      border: 0;
      background: #eeeeee;
      flex: 1;
      margin-left: 2vw;
    }
    img{
      width: 5.4vw;
      height: 5.4vw;
      margin-right: 5vw;
    }
  }
}

.mask{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(80, 79, 79, 0.534);
  display: flex;
  justify-content: center;
  align-items: center;
  & > div{
    width: fit-content;
    height: fit-content;
    text-align: center;
    font-size: 20px;
    line-height: 20px;
  }
  & > div > .text{
    margin-top: 10px;
  }
  ::v-deep .van-loading{
    margin: auto;
  }
}
.car-code-box{
  display: flex;
  flex-wrap: wrap;
}
.car-code-item{
  padding: 4px 0;
  width: 29%;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: calc(10% / 6);
  & ::v-deep .van-icon-cross{
    &::after{
      content: "";
      position: absolute;
      top: -10px;
      left: -10px;
      width: calc(100% + 20px);
      height: calc(100% + 20px);
    }
  }
}
.car-code-item:active{
  opacity: 0.5;
}

::v-deep .van-popup{
  border-radius: 4px;
  overflow: hidden;
}
::v-deep .van-field__control:disabled{
  -webkit-text-fill-color: #323233;
  color: #323233;
}
</style>